module.exports = __webpack_public_path__ + "static/valle-b3e8c93c093cd153c48e424884fbc744.png";